import { render, staticRenderFns } from "./packedRTicketTabs.vue?vue&type=template&id=b0b6fd8e&scoped=true&"
import script from "./packedRTicketTabs.vue?vue&type=script&lang=js&"
export * from "./packedRTicketTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b6fd8e",
  null
  
)

export default component.exports